var map = {
	"./Edamame Teriyaki psd 1.jpg": 1391,
	"./Edamame psd 1.jpg": 1139,
	"./Fried Manti psd 1.jpg": 4686,
	"./Kimchi psd 1.jpg": 4128,
	"./Onigiri Tempura.jpg": 1819,
	"./Onigiri.jpg": 57,
	"./Shrimp Chips psd 1.jpg": 9991,
	"./Shrimp psd 1.jpg": 5990,
	"./Spring Roll psd 1.jpg": 4258
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6481;